import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { PRINT_SELECT_IMAGES_VALIDATION, PrintSelectImageData, ThumbImagesDataEntity } from "../hooks/use-print-select-images";
import './print-select-images.card.scss';
import { Button } from "../../../../ui/button/button";
import rotateIcon from '../../../../../assets/img/icon/icon_rotate.svg';
import { VisibleSwitchContainer } from "../../print-create-order/component/print-item-setting";
import { TrimmingIcon } from "./svg/trimming.i";
import { DateFormatter } from "../../../../../utilities/date-formatter";
import { PrintImagesDataEntity } from "../../../../../api/sift/front/api-print-image";
import { useAppDispatch } from "../../../../../app/hooks";
import { useParams } from "react-router-dom";
import { PathParams } from "../../../../../routes/routing-path";
import iconEditTrim from '../../../../../assets/img/icon/icon_edit_trimming.svg';
type Props = {
  data: PrintSelectImageData,
  onClick: (id: string) => void,
  onInputSelect: (id: string, count: number) => void,
  largeView: boolean,
  onClickEdit: (imageId: string) => void,
  onRotate: (imageId: string) => void,
  getRotate: (image: PrintSelectImageData) => void,
  thumbImages: PrintImagesDataEntity[],
  validRotate: boolean,
  isTrimmed: (imageId: string) => boolean,
  saveThumbImageList: ThumbImagesDataEntity[],
}

const ImageNameLabel = (props: { name: string }) => {
  const {
    name = '',
  } = props;
  const splitName = useMemo(() => {
    const split = name.split('.');
    const [extension] = split.splice(split.length - 1, 1);
    const fileName = split.join('.');
    const last = fileName.slice(-4, fileName.length);
    const top = fileName.slice(0, fileName.length - 4);
    return {
      top,
      last: `${last}${extension ? `.${extension}` : ''}`
    }
  }, [name]);
  return (
    <div
      title={name}
      className="print_select_image__label"
    >
      <div className="print_select_image__label__top">{splitName.top}</div>
      <div className="print_select_image__label__last">{splitName.last}</div>
    </div>

  )
}

export const PrintSelectImageCard = (props: Props) => {
  const {
    data,
    onClick,
    onInputSelect,
    onClickEdit,
    largeView,
    validRotate,
    onRotate,
    getRotate,
    thumbImages,
    saveThumbImageList,
  } = props;
  const {
    kijshopCd,
  } = useParams<PathParams>()
  const viewDate = useMemo(() => {
    if (data.datePrint && !data.editableImage?.exif.createDate) {
      return '日付情報なし';
    }
    if (data.datePrint && data.editableImage?.exif.createDate) {
      return DateFormatter.date2str(data.editableImage?.exif.createDate, 'YYYYMMDD', '/');
    }
    return undefined;
  }, [data]);

  const src = useMemo(() => {
    const target = saveThumbImageList.find((v) => v.imageId === data.thumbId);
    if (data.thumbId && target) {
      return target.image;
    }
    return data.trimmingStatus === 2 ? undefined : data.thumbBase64;
  }, [data, saveThumbImageList]);

  const cnt = useRef<HTMLDivElement>(null);
  const inputContainer = useRef<HTMLInputElement>(null);
  const [count, setCount] = useState('');
  const handleClickImage = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (!src) return;
    e.preventDefault();
    e.stopPropagation();
    onClick(data.id);
  }, [data, src, onClick]);

  const handleChangeInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!data.count) return;
    setCount(e.target.value);
  }, [data]);
  const handleKeydownInput = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!e.nativeEvent.isComposing && e.key === 'Enter') {
      e.preventDefault();
      inputContainer.current?.blur();
    }
  }, []);
  const inputCount = useCallback((value: number) => {
    let resultValue = value;
    if (value < PRINT_SELECT_IMAGES_VALIDATION.min) {
      resultValue = PRINT_SELECT_IMAGES_VALIDATION.min;
    }
    if (value > PRINT_SELECT_IMAGES_VALIDATION.max) {
      resultValue = PRINT_SELECT_IMAGES_VALIDATION.max;
    }
    onInputSelect(data.id, resultValue);

  }, [data, onInputSelect]);
  const handleBlurInput = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const value = Number(e.target.value) || 0;
    inputCount(value);
  }, [inputCount]);

  const handleClickIncrement = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const value = Number(data.count) || 0;
    inputCount(value + 1);
  }, [inputCount, data]);

  const handleClickDecrement = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const value = Number(data.count) || 0;
    inputCount(value - 1);
  }, [inputCount, data]);

  const Icon = () => {
    if (props.isTrimmed(data.id)) {
      return (
        <div className="mode_icon edit_trim">
          <img src={iconEditTrim} alt="" />
        </div>
      );
    }
    if (data.id === '81b1d885-457b-4736-b899-3280601b18d1')  {
      console.log(data.trimmingStatus);
    }
    switch(data.trimmingStatus) {
      case 3:
       return (
          <div className="mode_icon trimming">
            <TrimmingIcon theme="on" size={18} />
          </div>
        );
      default:
       return <></>;
    }
  }

  useEffect(() => {
    setCount(`${data.count ?? ''}`);
  }, [data.count]);

  return (
    <div
      ref={cnt}
      className="print_select_image_wrapper"
    >
      <div
        className={`print_select_image ${src && data.count ? 'bold_border' : ''}`}
        style={{ height: src ? undefined : '210px' }}
        onClick={handleClickImage}
      >
        { src ? (
          <>
            <div
              className="print_select_image__image_wrap"
              data-direction={getRotate(data)}
            >
              {/* <div> */}
                <img src={src} alt={data.orgFilename} className={data.datePrint && src ? 'with_date' : ''} />
              {/* </div> */}
              {<div className={`date_label ${data.editableImage?.exif.createDate ? '' : 'invalid_date'}`}>{viewDate}</div>}
            </div>
            {/* <ImageNameLabel name={data.orgFilename} largeView={largeView} /> */}
            <ImageNameLabel name={data.orgFilename} />
            <VisibleSwitchContainer hidden={!data.count}>
              <div className="editable_wrap">
                <Button
                  label="トリミング編集"
                  className={`trimming_button ${data.trimmingStatus === 3 ? 'hidden' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onClickEdit(data.id);
                  }}
                />
                <div className="editable_wrap__bottom">
                  {!!validRotate && (
                    <Button
                      className="rotate_button"
                      icon={<img src={rotateIcon} alt=""/>}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        onRotate(data.id);
                      }}
                    />
                  )}
                  <div className="editable_wrap__input_cnt">
                    <button onClick={handleClickDecrement}>-</button>
                    <div className="editable_wrap__input_wrap">
                      <input
                        ref={inputContainer}
                        value={count}
                        type="number"
                        min={0}
                        max={9999}
                        onChange={handleChangeInput}
                        onKeyDown={handleKeydownInput}
                        onBlur={handleBlurInput}
                        className="editable_wrap__input"
                      />
                    </div>
                    <button onClick={handleClickIncrement}>+</button>
                  </div>
                </div>
              </div>
            </VisibleSwitchContainer>
          </>
        ) : (
          <div
            className="loading_popup__dots"
            style={{ fontSize: '0.5rem', animationDuration: `${1}s`, WebkitAnimationDuration: `${1}s` }}
          />
        ) }
      </div>
      <Icon />
      {/* {!!(data.datePrint && src) && (
        <div style={{ position: 'absolute', bottom: '1rem', right: '1rem', fontSize: '8px', zIndex: 50 }}>{viewDate}</div>
      )} */}
    </div>
  )

}
